import { render, staticRenderFns } from "./CustomApplications.vue?vue&type=template&id=065f36a0&scoped=true"
import script from "./CustomApplications.vue?vue&type=script&lang=js"
export * from "./CustomApplications.vue?vue&type=script&lang=js"
import style0 from "./CustomApplications.vue?vue&type=style&index=0&id=065f36a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f36a0",
  null
  
)

export default component.exports